var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cleaning"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_533_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.675,112h260.364c6.772-8,10.497-18.033,10.306-28.361c-0.212-11.452-5.018-22.08-13.531-29.545    c-4.635-4.064-11.917-8.963-20.29-8.963c-0.523,0-1.045-0.018-1.564,0c-21.727,0.765-42.184-7.714-56.141-23.233    C262.437,9.244,246.157,1.981,229.152,1.981c-17.108,0-33.454,7.33-44.845,20.113c-15.572,17.475-39.112,26.193-62.973,23.309    c-1.754-0.212-3.547-0.314-5.329-0.314c-5.327,0-10.905,2.229-16.579,6.601c-8.48,6.533-13.87,16.08-15.179,26.837    c-1.345,11.065,1.738,22.234,8.683,30.96L94.675,112z",
    id: "XMLID_534_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.141,153.939c0.366,0,0.727,0.061,1.083,0.061h192.984c6.39,0,11.589-5.11,11.589-11.501    c0-6.39-5.199-11.499-11.589-11.499H89.89c-0.004,0-0.008,0-0.012,0c-0.003,0-0.006,0-0.009,0H62.932    c-6.391,0-11.59,5.11-11.59,11.499c0,6.391,5.199,11.501,11.59,11.501h128.125C191.414,154,191.775,153.939,192.141,153.939z",
    id: "XMLID_535_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,371h27V229.079c0-3.598-1.713-6.986-4.262-9.54c-0.939-0.939-2.169-1.72-3.308-2.334    c-0.051-0.028-0.172-0.051-0.223-0.08c-1.901-0.993-3.773-1.525-5.984-1.526C351.793,215.6,346,221.647,346,229.079v116.983    c0,0.526,0.142,1.062,0.142,1.612c0,0.55-0.142,1.086-0.142,1.612V371z",
    id: "XMLID_536_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.345,419c-5.502,0-9.345-4.404-9.345-9.906V390h-27v19.091c0,5.502-5.041,9.909-10.543,9.909h-1.485    C318.785,419,307,431.409,307,446.596v6.358c0,0.745,0.282,1.518,0.282,2.318c0,0.799-0.282,1.573-0.282,2.318V465h110v-7.532    c0-0.708-0.251-1.441-0.251-2.197s0.251-1.489,0.251-2.197v-6.47c0-0.013,0.275-0.054,0.276-0.068    C417.256,431.365,405.181,419,390.005,419H382.345z",
    id: "XMLID_537_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,207.527V174H84.729l15.662,129.777C146.902,296.064,182,255.599,182,207.527z",
    id: "XMLID_538_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.198,465H437v9.771c0,5.502-3.988,10.229-9.49,10.229H296.466c-5.502,0-9.466-4.727-9.466-10.229V465    h-10.884l-7.46,45h192.002L453.198,465z",
    id: "XMLID_539_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,399.886v-18.924c0-0.026,0-0.051,0-0.077V358H107.004l16.136,132.537    C124.503,501.755,134.095,510,145.454,510h103.002l9.39-56.551c0.8-4.805,4.956-8.449,9.827-8.449h18.859    C287.142,423,304,403.821,326,399.886z",
    id: "XMLID_540_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,229.078c0-18.419,14.736-33.419,33.154-33.42c0.903,0,1.638-0.133,2.528-0.062L364.189,174H202    v33.527c0,58.161-42.745,107.446-99.166,116.375L104.582,338H326V229.078z",
    id: "XMLID_541_"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService1);
export default __webpack_public_path__ + "static/media/service1.c347b0db46f86161c5f76ccaa99c8751.svg";
export { ForwardRef as ReactComponent };